module.exports = __webpack_public_path__ + "img/products.9f819d36.png";